import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getSystemBaseAddress } from "../../../utils/getSystemBaseAddress";

export const getStewards = createAsyncThunk(
  "MAIN_GET_STEWARDS",
  async (province) => {
    const axiosInstance = axios.create();
    axiosInstance.defaults.headers.common = {};

    const apiUrl = `${getSystemBaseAddress(
      province
    )}pos_register_session_inspection/`;

    try {
      const response = await axiosInstance.get(apiUrl);
      const { data, status } = response;
      return { data, status };
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);
